import React from "react";
import { motion, AnimateSharedLayout, useCycle } from "framer-motion";
import "./styles.css";

export default function App() {
  const [screen, cycleScreen] = useCycle(1, 2, 3);

  return (
    <motion.div
      style={{ width: "100%", height: "100vh" }}
      onTap={() => cycleScreen()}
    >
      <AnimateSharedLayout>
        {screen === 1 && <Screen1 />}
        {screen === 2 && <Screen2 />}
        {screen === 3 && <Screen3 />}
      </AnimateSharedLayout>
    </motion.div>
  );
}

function Screen1() {
  return (
    <motion.div
      layoutId="screen"
      className="screen"
      initial={{ backgroundColor: "#09f" }}
      animate={{ backgroundColor: "#09f" }}
    >
      <motion.div
        layoutId="box"
        className="box"
        style={{
          top: "50%",
          left: "50%",
          margin: "-60px 0 0 -60px",
          borderRadius: 20
        }}
      />
    </motion.div>
  );
}

function Screen2() {
  return (
    <motion.div
      layoutId="screen"
      className="screen"
      animate={{ backgroundColor: "#63f" }}
    >
      <motion.div
        layoutId="box"
        className="box"
        style={{
          top: 60,
          right: 90,
          borderRadius: 60
        }}
      />
    </motion.div>
  );
}

function Screen3() {
  return (
    <motion.div
      layoutId="screen"
      className="screen"
      animate={{ backgroundColor: "#fb0" }}
    >
      <motion.div
        layoutId="box"
        className="box"
        style={{
          bottom: 60,
          left: 90,
          borderRadius: 20,
          rotate: -45
        }}
      />
    </motion.div>
  );
}
